/**
 * --------------------------------------------------
 * Rithum Application
 * @module rithum
 * --------------------------------------------------
 */

// Import jQuery
import $ from 'jquery';

// expose to globals:
window.$      = jQuery;
window.jQuery = jQuery;

// Import required modules
import Navigation from './modules/navigation.js';
import Modal from './modules/modal.js';

// temporary import for testing
import CardList from './modules/card-list.js';
import Marketo from './modules/marketo.js';

// Export the Rithum application
export default {
    ready() {
        $(document).ready(function () {
            console.log('Rithum Application is ready');

            // Initialize navigation module
            Navigation.setup();

            // Temporary: test cards module
            CardList.setup();

            // Initialize Marketo (temporary)
            Marketo.setup();

            // Initialize modal module
            Modal.init();

        });
    }
}